export const getLocation = async () => {
    try {
        const response = await fetch("https://ipinfo.io/json?token=1e5146def9ab58");
        if (!response.ok) throw new Error("Error obteniendo la ubicación");
        
        const data = await response.json();
        
        return {
            countryCode: data.country?.toLowerCase() || "us", // Código del país en minúsculas (ej: 'co', 've')
        };
    } catch (error) {
        console.error("Error obteniendo la ubicación:", error);
        return { countryCode: "us" }; // Valor por defecto en caso de error
    }
};
